import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Dropdown, Icon } from 'semantic-ui-react'

class SortingDropdownItem extends Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    handleSort: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }

  handleChoice = (e, { value }) => {
    const { handleSort } = this.props

    handleSort(value)
  }

  render() {
    const { active, icon, name, sortOrder, text } = this.props

    return (
      <Dropdown.Item active={active} onClick={this.handleChoice} value={name}>
        <Icon name={icon} />

        {text}

        {active && <Icon name={sortOrder === 'ascending' ? 'caret up' : 'caret down'} />}
      </Dropdown.Item>
    )
  }
}

export default SortingDropdownItem
